module.exports = __webpack_public_path__ + "static/media/Monogram_Background@2x.7edd5758.png";